module.exports = __webpack_public_path__ + "static/media/washer.c23d0dbe.svg";